<template lang="pug">
    section#BannerProuni
        picture.bg
            source(srcset="@images/banners/banner-prouni-2022-1920x260-v2.png", media="(min-width: 601px)")
            source(srcset="@images/banners/banner-prouni-2022-600x490-v2.jpg", media="(max-width: 600px)")
            img(src="@images/banners/banner-prouni-2022-1920x260.png")
</template>

<script>
export default {
    name: "component-banner-prouni",
    props:{
        nomePagina: String
    }
}
</script>

<style lang="stylus" scoped src="./BannerProuni.styl"></style>